<template>
  <div>
    <page-seo class="mb-10" :data="pageSeo" />
  </div>
</template>

<script>
  import PageSeo from '@/components/form/PageSeo'

  export default {
    components: { PageSeo },
    computed: {
      pageSeo: {
        get() {
          return this.$store.state.page.data.aboutUsSeo
        }
      }
    }
  }
</script>
